<template>
    <div class='t_content_view'>
        <div class="t_search_box">
            <div class="t_search_select" >
                <img src="../assets/img/searchgray.png" style="width:14px" alt="">
                <el-input @input="searchinput" size="small" v-model="searchdata.task_name" placeholder="请输入任务名称"  clearable />
            </div> 
            <div class="t_search_select" >
                <img src="../assets/img/searchgray.png" style="width:14px" alt="">
                <el-input @input="searchinputcreateBy" size="small" v-model="searchdata.creator" placeholder="请输入创建成员"  clearable />
            </div> 
            <div class="t_search_select" >
                <el-select style="width: 180px;" @change="changestatus" v-model="searchdata.task_status" clearable placeholder="任务状态" size="small"  >
                    <el-option v-for="item in options.data" :key="item.id" :label="item.title" :value="item.id" />
                </el-select> 
            </div> 
            <div class="t_search_select" style="margin-right:20px;margin-left:20px">
                <span style="color: #6D6D6D;">执行时间：</span>
                <el-date-picker
                    v-model="dotime.data"
                    @change="changedoTime"
                    size="small" 
                    value-format="YYYY-MM-DD HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                />
            </div>
            <div class="t_search_select" style="margin-right:20px;margin-left:20px">
                <span style="color: #6D6D6D;">创建时间：</span>
                <el-date-picker
                    v-model="createtime.data"
                    @change="changecreateTime"
                    size="small" 
                    value-format="YYYY-MM-DD HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                />
            </div>
            <!-- <div class="t_search_select" >
                <el-select v-model="searchdata.scanUserId" @change="changesm" clearable placeholder="扫码号" size="small"  >
                    <el-option style="height: auto;line-height: normal;padding:8px 32px 8px 20px" v-for="(item,index) in allpeolist.data" 
                        :key="index"
                        :value="item.id" :label="item.name" >
                        </el-option>
                </el-select>
            </div>  -->

            <el-button @click="resetsearch" color="#F1F3F9" type="primary" style="margin-bottom: 10px;">重置</el-button>
        </div>
        <div style="margin-top: 20px;margin-bottom: 20px;">
            <router-link to="/navtkyl/phonefriendaddgth" style="margin-right: 12px;">
                <el-button   color="#4F46E5" type="primary">新建任务</el-button>
            </router-link>
            <el-button @click="exportfrlist"  color="#4F46E5" type="primary">导出任务</el-button>
            <el-button  @click="exportsq(0)"  color="#4F46E5" type="primary">导出全部记录</el-button>
           
            
        </div>
        <el-table :header-cell-style="{ background: '#F1F3F9' }" :data="tableData.data" style="width: 100%" @selection-change="handleSelectionChange">
            <!-- <el-table-column type="selection" width="55" /> -->
            <el-table-column prop="task_name" label="任务名称"  />
            <el-table-column prop="created_at" width="110" label="创建时间"  />
            <el-table-column prop="task_time" width="110" label="执行时间"  />
            <el-table-column prop="username" width="110" label="创建成员"  />
            <el-table-column prop="title" label="扫码号" width="150"   >
                <template #default="scope">
                   <div v-if="scope.row.add_by[0]!=null">
                    <el-tooltip
                        v-if="scope.row.add_by.length < 6" v-for="(item, index) in scope.row.add_by" :key="index"
                        class="box-item"
                        effect="dark"
                        :content=item.name
                        placement="top">
                        <img 
                            style="width:30px;height: 30px;margin-left:-10px;border:1px solid white;border-radius: 50%;"
                            :src="item.avatar" alt="">
                    </el-tooltip>
                    
                    <div class="t_more_img" v-else>
                        <el-tooltip
                            v-for="(item, index2) in scope.row.add_by.slice(0, 5)" :key="index2"
                            class="box-item"
                            effect="dark"
                            :content=item.name
                            placement="top">
                            <img 
                            style="width:30px;height: 30px;margin-left:-10px;border:1px solid white;border-radius: 50%;"
                            :src="item.avatar" alt="">
                        </el-tooltip>
                        <div class="t_more">{{ scope.row.add_by.length }}</div>
                    </div>
                   </div>
                    
                </template>
            </el-table-column>
            <!-- <el-table-column prop="add_by" label="创建成员"  /> -->
            <el-table-column prop="import_num" label="导入数量"  />
            <el-table-column prop="valid_import_num" label="有效导入数"  />
            <el-table-column prop="send_num" label="已发起申请"  />
            <el-table-column prop="valid_send_num" label="有效申请数"  />
            <el-table-column prop="success_num" label="成功添加"  /> 
            <el-table-column prop="" label="有效申请率"  >
                <template #default="scope">
                    {{ GetPercent(scope.row.valid_send_num,scope.row.send_num) }}%
                </template>
            </el-table-column>
            <el-table-column prop="" label="成功添加率"  >
                <template #default="scope">
                    {{ GetPercent(scope.row.success_num,scope.row.send_num) }}%
                </template>
            </el-table-column>
            <el-table-column prop="task_status" label="任务状态" >
                <template #default="scope">
                    <span v-if="scope.row.task_status==0">
                        未开始
                    </span>
                    <span v-if="scope.row.task_status==1">
                        进行中
                    </span>
                    <span v-if="scope.row.task_status==2">
                        已终止
                    </span>
                    <span v-if="scope.row.task_status==3">
                        已完成
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="address"  label="操作" >
                <template #default="scope">
                    <el-button @click="stopcz(scope.row.id)" style="color:#4F46E5;padding: 0;" size="small" type="text" >终止</el-button>

                    <el-button @click="delitem(scope.row.id)" style="color:#4F46E5;padding: 0;margin-left: 5px;" size="small" text >删除</el-button>

                    <div>
                        <el-button @click="exportsq(scope.row.id)" size="small" style="color:#4F46E5;padding: 0;" type="text">导出申请记录</el-button>
                    </div>

                    <!-- <el-button v-if="scope.row.task_status==0||scope.row.task_status==1" @click="tocopy(scope.row.id,'bj')"  style="color:#4F46E5;padding: 0;margin-left: 5px;" size="small" text >编辑</el-button>






                    <el-button @click="tocopy(scope.row.id,'fz')"  style="color:#4F46E5;padding: 0;margin-left: 0;" size="small" type="text" >复制</el-button>
                    <el-button @click="todetail(scope.row.id)" style="color:#4F46E5;padding: 0;margin-left: 0;" size="small" type="text" >详情</el-button>
                    -->
                    
                    
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <pagechange :total="total" :nowpage="searchdata.page" @page_change="page_change" />
    </div>
    
</template>

<script setup>
import { ref, reactive, provide, onBeforeMount, onMounted, watch ,inject} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
//导入子组件
import pagechange from '../components/pagechange.vue'
import { friendlist,stoplist,delfriendlist,newaddfriendlist,newgetpeo,newdelfriend,newstopfriend,newfriendexport,newfriendexportask } from '@/assets/js/common.js'
//路由跳转
const router = useRouter()
//获取数据
const route = useRoute()
//动态获取接口地址
const _url2 = inject('_url2')
onMounted(() => {
    console.log('onMounted')
    getallpeolist()
    //人员列表
    getlist()
})
//所有成员下拉数组
const allpeolist = reactive({
    data:[]
})
//获取所有成员下拉
const getallpeolist = ()=>{
    newgetpeo().then((response)=>{
        if (response.data.msg.code == 0) {
            // console.log(response.data.result)
            allpeolist.data = response.data.data
        }
    })
}

//监听搜索文本框内容变化
const searchinput = (e)=>{
    console.log(e)
    searchdata.task_name = e
    searchdata.page=1
    getlist()
}
//监听搜索文本框内容变化
const searchinputcreateBy = (e)=>{
    console.log(e)
    searchdata.creator = e
    searchdata.page=1
    getlist()
}
//任务状态下拉
const options = reactive({
    data:[
      {
        id:0,
        title:'未开始'
      },
      {
        id:1,
        title:'进行中'
      },
      {
        id:2,
        title:'已终止'
      }, 
      {
        id:3,
        title:'已完成'
      },   
    ]
})
//选择状态
const changestatus = (e)=>{
    console.log(e)
    searchdata.task_status = e
    searchdata.page=1
    getlist()
}
//执行时间
const dotime = reactive({
    data:[]
})
//监听执行时间改变
const changedoTime = (e)=>{
    console.log(e)
    if(e==null){
        searchdata.task_time_start = ''
        searchdata.task_time_end = ''
    }else{
        searchdata.task_time_start = e[0]
        searchdata.task_time_end = e[1]
    }
    searchdata.page=1
    getlist()
}
//创建时间
 const createtime = reactive({
    data:[]
 })
 //监听创建时间改变
const changecreateTime = (e)=>{
    console.log(e)
    if(e==null){
        searchdata.created_at_start = ''
        searchdata.created_at_end = ''
    }else{
        searchdata.created_at_start = e[0]
        searchdata.created_at_end = e[1]
    }
    searchdata.page=1
    getlist()
}
//修改扫码号
const changesm = (e)=>{
    console.log(e)
    searchdata.scanUserId = e
    searchdata.page=1
    getlist()
}
//搜索内容
const searchdata  = reactive({
    task_name:'',
    creator:'',
    page:1,
    page_size:20,
    task_status:'',
    task_time_start:'',
    task_time_end:'',
    created_at_start:'',
    created_at_end:'',
    type:1
    // scanUserId:'',
    // addType:1
})
//重置
const resetsearch = ()=>{
    searchdata.task_name=''
    searchdata.creator=''
    searchdata.task_status=''
    searchdata.task_time_start=''
    searchdata.task_time_end=''
    searchdata.created_at_start=''
    searchdata.created_at_end=''
    // searchdata.scanUserId=''
    searchdata.page=1
    dotime.data = []
    createtime.data = []
    getlist()
}
//导出列表
const exportfrlist = ()=>{

    newfriendexport(searchdata).then((response)=>{
        if(response.data.msg.code==0){
            console.log(response)
            // window.open(response.data.data)
            const a = document.createElement('a');
            a.setAttribute('download', '');
            a.setAttribute('href', response.data.data);
            a.click();
        }
    })
    // var exportL = JSON.parse(JSON.stringify(searchdata));
    // exportL.corpId  = $cookies.get("fanscorpId")
    
    // var str = '?'
    // for (let key in exportL) {
    //     str=str+key+'='+exportL[key]+'&'
        
    // }
    // console.log( str.slice(0, -1))
    // const a = document.createElement('a');
    // a.setAttribute('download', '');
    // a.setAttribute('href', _url2 + `/work/bcAddFriendTask/exportXls`+ str.slice(0, -1));
    // a.click();
    
}
//导出申请记录
const exportsq = (id)=>{
    newfriendexportask({id:id,type:1}).then((response)=>{
        if(response.data.msg.code==0){
            console.log(response)
            // window.open(response.data.data)
            const a = document.createElement('a');
            a.setAttribute('download', '');
            a.setAttribute('href', response.data.data);
            a.click();
        }
    })
    // const a = document.createElement('a');
    // a.setAttribute('download', '');
    // a.setAttribute('href', _url2 + `/work/bcAddFriendTask/exportXlsApply?addType=1&taskId=`+id+'&corpId='+$cookies.get("fanscorpId"));
    // a.click();
}
//列表内容
const tableData = reactive({
    data:[]
})
//总数
const total = ref(0)
//监听分页
const page_change = (val)=>{
    searchdata.page = val
    //人员列表
    getlist()
}

//获取列表
const getlist = ()=>{
    newaddfriendlist(searchdata).then((response)=>{
        console.log(response)
        tableData.data = response.data.data.data
        total.value = response.data.data.total
    })
    console.log('获取列表')
}
//多选
const delarr = reactive({
    data:[]
})
const handleSelectionChange = (val)=>{
    delarr.data = val
}

//跳转详情
const todetail = (id)=>{
    router.push({path:'/navtkyl/phonefrienddetail',query:{id:id,addType:1}})
}
//跳转复制
const tocopy = (id,type)=>{
    router.push({path:'/navtkyl/phonefriendadd',query:{id:id,type:type}})
}
//计算百分比
const GetPercent = (num,total)=>{
        // var num = 50
        // var total = 100
        num = parseFloat(num);
        total = parseFloat(total);
        if (isNaN(num) || isNaN(total)) {
            return 0;
        }

        console.log(total <= 0 ? 0 : (Math.round(num / total * 10000) / 100.00))
        //返回  12.62

        return total <= 0 ? 0 : (Math.round(num / total * 10000) / 100.00);
        
}
//终止
const stopcz = (id)=>{
    ElMessageBox.confirm(
    '知否确认终止',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
        newstopfriend({id:id}).then((response)=>{
            console.log(response)
            if(response.data.msg.code==0){
                ElMessage({
                    type: 'success',
                    message: '操作成功',
                })
            }
            
        })
      
    })
    .catch(() => {
      ElMessage({
        type: 'info',
        message: '已取消',
      })
    })
}
//删除
const delitem = (id)=>{
    ElMessageBox.confirm(
    '知否确认删除',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
        newdelfriend({id:id}).then((response)=>{
            console.log(response)
            if(response.data.msg.code==0){
                ElMessage({
                    type: 'success',
                    message: '操作成功',
                })
                getlist()
            }
            
        })
      
    })
    .catch(() => {
      ElMessage({
        type: 'info',
        message: '已取消',
      })
    })
}


</script>

<style scoped>
:deep(.t_search_box .el-input__wrapper) {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
:deep( .t_input_bg .el-input__wrapper) {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
:deep(.t_textarea_nobod .el-textarea__inner) {
    
    box-shadow: 0 0 0 0 ;
    resize: none;
    border-bottom: 1px solid #dcdfe6;
}
.t_tips_font{
    color: #777777;
    font-size: 13px;
    line-height: 18px;
}
.t_more_img {
    display: flex;
    flex-wrap: wrap;
}

.t_more {
    width: 30px;
    height: 30px;
    margin-left: -10px;
    border: 1px solid white;
    border-radius: 50%;
    background-color: rgb(206, 206, 206);
    text-align: center;
    line-height: 30px;
}
:deep(.t_search_select .el-select__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
</style>